import 'slick-carousel';
import { getButton } from '../helpers/sliderHelpers';

const $sliders = $('.js-slider');

const generalSlider = {
  initialize() {
    if ($sliders.length) {
      this.create();
    }
  },

  create() {
    $sliders.each((i, slider) => {
      const $slider = $(slider);
      const options = $slider.data();

      const config = {
        prevArrow: getButton('Vorige', 'slider__arrow slick-prev', 'arrow-left'),
        nextArrow: getButton('Volgende', 'slider__arrow slick-next', 'arrow-right'),
      };

      if (typeof options !== 'undefined') {
        const optionKeys = Object.keys(options);

        optionKeys.forEach((option) => {
          const regex = /^slider/g;

          if (regex.test(option)) {
            let transformedOption = option.replace('slider', '');
            transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

            config[transformedOption] = options[option];
          }
        });
      }

      $slider.slick(config);
    });
  },
};

export default generalSlider;
